export default __webpack_public_path__ + "static/media/jwcc.002edd9e.png";